import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../../base/base.component';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountService } from '../../../services/account.service';
import { SessionCreditVM } from '../../../models/SessionCreditVM';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { RedeemSessionService } from '../../../services/redeemsession.service';
import { CounsellorSearchRequestVM } from '../../../models';

@Component({
  selector: 'redeem-session',
  templateUrl: './redeemsession.component.html'
})
export class RedeemSessionComponent extends BaseComponent implements OnInit {

  toggleSearch: boolean = false;
  request: CounsellorSearchRequestVM;
  model: SessionCreditVM = null;

  results: any[] = [];
  totalFound: number = 0;

  constructor(
    private searchService: RedeemSessionService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private router: Router) {
    super(route);
  }

  ngOnInit(): void {
    if (this.route.snapshot.data['credit']) {
      this.model = this.route.snapshot.data['credit'];
    }
    if (this.model == null) {
      this.router.navigateByUrl('/');
    }

    if (this.searchService.searchRequest == null)
      this.searchService.searchRequest = new CounsellorSearchRequestVM();

    this.request = this.searchService.searchRequest;
    this.request.continuationToken = ''; //ensure continuation token is empty

    this.myForm = this.fb.group({
      counsellorName: new FormControl(this.request.counsellorName),
      gender: new FormControl(null),
      language: new FormControl(this.request.language),
      country: new FormControl(this.request.country),
      state: new FormControl(null),
      counsellingTopic: new FormControl(this.request.counsellingTopic),
      sessionType: new FormControl(null),
      availability: new FormControl(null)
    });

    this.onSubmit("");
  }

  toggleAdvancedSearch() {
    this.toggleSearch = (this.toggleSearch) ? false : true;
  }

  onSubmit(value: string) {
    this.markAsTouched(this.myForm);
    if (this.myForm.valid) {
      this.emitDisplayLoadingDialog(true);
      var self = this;
      this.searchService.initSearch(this.request, this.model)
        .subscribe(returnValue => {
          if (returnValue) {
            //load results to screen
            if (self.searchService.searchRequest != null) {
              self.results = self.searchService.results;
              self.totalFound = self.searchService.paging.totalItems;
            }
          }
          self.emitDisplayLoadingDialog(false);
        },
          e => {
            console.log(e);
            self.showDialog(e, true);
            self.emitDisplayLoadingDialog(false);
          },
          () => {
            self.emitDisplayLoadingDialog(false);
          }
        );
    }
  }

  loadMoreResults() {
    if (this.searchService.hasMoreResults()) {
      this.emitDisplayLoadingDialog(true);
      this.searchService.loadMoreResults(this.model)
        .subscribe(returnValue => {
          this.refreshResults();
        },
          error => {
            this.emitDisplayLoadingDialog(false);
          });
    }
  }

  viewProfile(mbno: string) {
    this.emitDisplayLoadingDialog(true);
    this.router.navigateByUrl('/profile/' + mbno);
  }

  refreshResults() {
    this.emitDisplayLoadingDialog(false);
    this.results = this.searchService.results;
  }

  hasMoreResults(): boolean {
    return this.searchService.hasMoreResults();
  }

}
